import { c as _c } from "react/compiler-runtime";
import { Icon, type IconNames } from '@petsmart-ui/sparky';
import type { MouseEvent } from 'react';
import { getBaseUrlJoined, trackNavigationHeaderClick } from '@libs/analytics';
import { useCart, useLogout } from '@libs/common-next';
import { handleAccountClick } from '@libs/experience-api';
import './links.scss';
type LinksProps = {
  onAction: () => void;
};
type NavigationClickInput = {
  event: MouseEvent<HTMLAnchorElement>;
  href: string;
  selection: string;
};
const SIGN_OUT_HREF = '/sign-in';
const NAV_LINKS = [{
  href: '/account/about-you',
  iconName: 'account-circle-outline',
  label: 'About you',
  selection: 'about you'
}, {
  href: '/account/order-history',
  iconName: 'box-outline',
  label: 'Orders',
  selection: 'orders'
}, {
  href: '/treats-rewards/authenticated/offers',
  iconName: 'treats-icon',
  label: 'Offers',
  selection: 'offers'
}, {
  href: '/account/auto-ship',
  iconName: 'autoship-outline',
  label: 'Autoship',
  selection: 'autoship'
}, {
  href: '/account/services-grooming',
  iconName: 'calendar-outline',
  label: 'Appointments',
  selection: 'appointments'
}, {
  href: '/account/address-book',
  iconName: 'address-outline',
  label: 'Addresses',
  selection: 'addresses'
}, {
  href: '/account/credit-cards',
  iconName: 'wallet-outline',
  label: 'Payments',
  selection: 'payments'
}, {
  href: '/account/favorites',
  iconName: 'heart-outline',
  label: 'Favorites',
  selection: 'favorites'
}];
function trackAccountNavClick(selection: string, href: string) {
  trackNavigationHeaderClick(selection, getBaseUrlJoined(href) ?? href);
}
export function Links(t0) {
  const $ = _c(14);
  const {
    onAction
  } = t0;
  const {
    clearCart
  } = useCart();
  const logout = useLogout();
  let t1;
  if ($[0] !== onAction) {
    t1 = async function handleNavClick(t2) {
      const {
        event,
        href,
        selection
      } = t2;
      trackAccountNavClick(selection, href);
      onAction();
      await handleAccountClick({
        event,
        href
      });
    };
    $[0] = onAction;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleNavClick = t1;
  let t2;
  if ($[2] !== clearCart || $[3] !== logout || $[4] !== onAction) {
    t2 = function handleLogout() {
      trackAccountNavClick("sign out", SIGN_OUT_HREF);
      onAction();
      logout({
        redirectUrl: SIGN_OUT_HREF,
        forceRedirect: true,
        callback: clearCart
      });
    };
    $[2] = clearCart;
    $[3] = logout;
    $[4] = onAction;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleLogout = t2;
  let t3;
  if ($[6] !== handleNavClick) {
    t3 = NAV_LINKS.map(link => <li key={link.label}><a href={link.href} className="account-authenticated-links__link" onClick={async event_0 => {
        await handleNavClick({
          event: event_0,
          href: link.href,
          selection: link.selection
        });
      }}><Icon name={link.iconName as IconNames} size="sm" aria-hidden="true" />{link.label}</a></li>);
    $[6] = handleNavClick;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon name="signout-outline" size="sm" aria-hidden="true" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handleLogout) {
    t5 = <li><button type="button" className="account-authenticated-links__link" onClick={handleLogout}>{t4}Sign out</button></li>;
    $[9] = handleLogout;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <ul className="account-authenticated-links">{t3}{t5}</ul>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}